import React from 'react';
import { FormInputRadio } from '../../../common/formInputs/FormInputRadio';
import { flagResponse } from '../../../common/constants';

const questions = {
  in_good_condition: {
    label: 'Il fabbricato è in buone condizioni di statica e manutenzione?',
    name: 'in_good_condition',
  },
  has_building_violation: {
    label: 'Il fabbricato risulta gravato da abuso edilizio?',
    name: 'has_building_violation',
  },
  under_construction: {
    label:
      'Il fabbricato è in corso di costruzione, ristrutturazione o ampliamento?',
    name: 'under_construction',
  },
  meets_insurance_requirements: {
    label: 'Risponde ai requisiti di assicurabilità?',
    name: 'meets_insurance_requirements',
  },
  matches_insured_data: {
    label: 'Risponde ai dati del fabbricato assicurato?',
    name: 'matches_insured_data',
  },
  no_other_policies: {
    label: 'Non sono in vigore altre polizze per gli stessi rischi?',
    name: 'no_other_policies',
  },
  no_canceled_policies: {
    label: 'Nessuna polizza annullata nel triennio precedente?',
    name: 'no_canceled_policies',
  },
  no_past_damages: {
    label: 'Nessun evento dannoso nel triennio precedente?',
    name: 'no_past_damages',
  },
};
function CommercialCatastropheContractorDeclaration({
  errors,
  isValid,
  register,
}) {
  return (
    <>
      <h4 className="text-center mt-3">Dichiarazioni del contraente</h4>
      <div className="row mt-5 d-flex justify-content-center">
        <div className="col-12 col-md-6 mb-4">
          <div className="card border">
            <div className="card-body">
              <div className="col-12">
                <div className="d-flex flex-column align-items-center justify-content-center gap-5" style={{ maxWidth: '600px' }}>
                  {Object.values(questions).map((question, index) => (
                    <FormInputRadio
                      key={index}
                      label={question.label}
                      options={flagResponse}
                      name={question.name}
                      error={errors?.contractor_declaration?.[question.name]?.message}
                      valid={isValid(
                        `contractor_declaration.${question.name}`,
                      )}
                      registration={register(
                        `contractor_declaration.${question.name}`,
                      )}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommercialCatastropheContractorDeclaration;
